import xor from 'lodash/xor'

/**
 * returns true if the response1 and the response2 contains exactly the same items
 * (ignore the order)
 *
 * @param {{ value: string[] }} response1
 * @param {{ value: string[] }} response2
 */
export function sameItems(response1, response2) {
  return xor(response1.choices, response2.choices).length === 0
}
